// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2(props) {
    return (
        <svg
            id="_x32_"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st5, .st6 {\n        stroke: #fff;\n      }\n\n      .st4, .st5, .st6 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st7, .st8, .st9 {\n        isolation: isolate;\n      }\n\n      .st10, .st8 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st8 {\n        font-size: 11px;\n      }\n\n      .st8, .st9 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st9 {\n        font-size: 5px;\n      }\n\n      .st5 {\n        stroke-width: .8px;\n      }\n\n      .st5, .st6 {\n        stroke-miterlimit: 4;\n      }\n\n      .st6 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="BAL">
                <g id="BAL1">
                    <g id="compass">
                        <polygon
                            className="st3"
                            points="231.9 207 225.6 200.3 222.6 192.9 228.3 198.5 231.9 207"
                        />
                        <path
                            className="st13"
                            d="M235.7,212.4c-7.1,4.8-16.7,2.9-21.5-4.2-4.8-7.1-2.9-16.7,4.2-21.5,7.1-4.8,16.7-2.9,21.5,4.2,4.8,7.1,2.9,16.7-4.2,21.5ZM219.1,187.7c-6.5,4.4-8.2,13.2-3.8,19.7s13.2,8.2,19.7,3.8,8.2-13.2,3.8-19.7c-4.4-6.4-13.2-8.1-19.7-3.8Z"
                        />
                        <path
                            className="st3"
                            d="M227.6,196.6c1.6.3,2.7,1.9,2.3,3.5-.3,1.6-1.9,2.7-3.5,2.3-1.6-.3-2.7-1.9-2.3-3.5.3-1.6,1.9-2.6,3.5-2.3Z"
                        />
                        <path
                            className="st3"
                            d="M220.8,192.5l-1.7-2.6.4-.3,2.4,1h0l-1.2-1.8.4-.3,1.7,2.6-.4.3-2.4-1h0l1.2,1.8-.4.3Z"
                        />
                        <path
                            className="st11"
                            d="M227.3,197.9c.9.2,1.5,1,1.3,1.9s-1,1.5-1.9,1.3-1.5-1-1.3-1.9,1-1.5,1.9-1.3Z"
                        />
                    </g>
                    <g id="distances">
                        <g id="right" className="st7">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <text
                                            className="st8"
                                            transform="translate(223.2 114.4)"
                                        >
                                            <tspan x={0} y={0}>
                                                318
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="right-center" className="st7">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <text
                                            className="st8"
                                            transform="translate(185.1 55.3)"
                                        >
                                            <tspan x={0} y={0}>
                                                373
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="center" className="st7">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <text
                                            className="st8"
                                            transform="translate(105.7 30.3)"
                                        >
                                            <tspan x={0} y={0}>
                                                410
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="left" className="st7">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <text
                                            className="st8"
                                            transform="translate(38.6 61.4)"
                                        >
                                            <tspan x={0} y={0}>
                                                363
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="left1" className="st7">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <text
                                            className="st8"
                                            transform="translate(4.9 101.9)"
                                        >
                                            <tspan x={0} y={0}>
                                                333
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="field">
                        <path
                            id="warning_track"
                            className="st12"
                            d="M27.2,105.1l-.5-4-1.8-5.6-2-6,1-3,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.6-.8,3.8,1.9,2.6-.6,2.2-1.5,2.2-1.5,2.2-1.5,2.2-1.5,2.3-1.6,2.3-1.6,2.3-1.6,2.4-1.6,2.4-1.6,2.4-1.7,2.5-1.7,2.5-1.7,2.5-1.7,2.6-1.7,2.6-1.8,2.6-1.8,2.7-1.8,2.7-1.9,2.8-1.9,3-.2,3,.8,3,.8,3,.8,2.9.8,2.9.8,2.9.8,2.8.8,2.8.8,2.8.7,2.8.8,2.8.7,2.7.7,2.7.8,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.7.7,2.4,1.6,2,2.7,1.9,2.7,1.8,2.7,1.7,2.6,1.7,2.6,1.7,2.5,1.7,2.5,1.7,2.4,1.6,2.4,1.6,2.3,1.6,2.2,1.5,2.2,1.5,2.2,1.5,2.2,1.5,2.1,1.5,2.1,1.5,2.1,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.4,2,1.3,2,1.3,2,3.3,11.6c-1.3,2-9.2-.5-10.9,2-17.6,25.7-53.7,77.2-64.4,88.6-13.8,14.9-27.2,23.4-46-3.1-7-9.9-19.1-26.8-31.5-43.6l-2.2.9c-20.3-27.6-40.3-58.2-40.3-58.2l.5-2.6v.2Z"
                        />
                        <path
                            id="grass"
                            className="st10"
                            d="M175.2,58.2l-61.9-17.2-29.6,20-19,12.1-7-.6-1.6.9-25.1,17.4,4.2,13.8-1.3,3.3s47.1,68,70.5,97.3c6.2,8.8,12.9,15.5,20.3,15.5s15.1-8.3,18.6-13.4c2.6-3.7,11.8-11.9,21.7-26.5,19.7-28.9,46.1-70.4,46.1-70.4l-35.8-52.3h-.1Z"
                        />
                        <path
                            id="infield_sand"
                            className="st12"
                            d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
                        />
                    </g>
                    <g id="persistent">
                        <g id="mound">
                            <path
                                id="pitching-mound"
                                className="st12"
                                d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                            />
                            <rect
                                id="pitching-rubber"
                                className="st4"
                                x={123.2}
                                y={176.6}
                                width={4}
                                height={1.6}
                            />
                        </g>
                        <g id="lines">
                            <line
                                id="left-foul-line"
                                className="st2"
                                x1={125.2}
                                y1={203.2}
                                x2={27}
                                y2={105.1}
                            />
                            <line
                                id="right-foul-line"
                                className="st2"
                                x1={125.2}
                                y1={203.2}
                                x2={218.7}
                                y2={109.6}
                            />
                        </g>
                        <g id="bases">
                            <rect
                                id="third-base"
                                className="st6"
                                x={99.2}
                                y={175.1}
                                width={3}
                                height={3}
                                transform="translate(-95.4 122.9) rotate(-45)"
                            />
                            <rect
                                id="first-base"
                                className="st6"
                                x={148.1}
                                y={175.2}
                                width={3}
                                height={3}
                                transform="translate(-81.1 157.5) rotate(-45)"
                            />
                            <rect
                                id="second-base"
                                className="st5"
                                x={123.7}
                                y={148.6}
                                width={3}
                                height={3}
                                transform="translate(-69.5 132.5) rotate(-45)"
                            />
                            <polygon
                                id="home"
                                className="st4"
                                points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                            />
                        </g>
                    </g>
                </g>
                <g id="grid" className="st14">
                    <g>
                        <g id="numbers">
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(91 184.1) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    90
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(56.5 153.8) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    200
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(71 168.4) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    150
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(80.4 177.7) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    120
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(41.6 139) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    250
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(27.5 124) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    300
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(12.7 109.2) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    350
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(15 75.9) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    400
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(15 49.4) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    450
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="st7">
                                <g className="st7">
                                    <g className="st7">
                                        <g className="st7">
                                            <text
                                                className="st9"
                                                transform="translate(15 24.6) rotate(-44.2)"
                                            >
                                                <tspan x={0} y={0}>
                                                    500
                                                </tspan>
                                            </text>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="surface29">
                            <path className="st1" d="M125.5,203.8L-22.5,55.8" />
                            <path className="st1" d="M124.8,203.8L272.8,55.8" />
                            <path className="st0" d="M125.1,203.5L45.4,10.9" />
                            <path className="st0" d="M125.1,203.5V-4.9" />
                            <path className="st0" d="M125.1,203.5L204.9,10.9" />
                        </g>
                        <path
                            id="_x31_00-line"
                            className="st1"
                            d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                        />
                        <path
                            id="_x32_00-line"
                            className="st1"
                            d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
                        />
                        <path
                            id="_x39_0-line"
                            className="st1"
                            d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
                        />
                        <path
                            id="_x31_20-line"
                            className="st1"
                            d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
                        />
                        <path
                            id="_x32_50-line"
                            className="st1"
                            d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
                        />
                        <path
                            id="_x33_00-line"
                            className="st1"
                            d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                        />
                        <path
                            id="_x33_50-line"
                            className="st1"
                            d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
                        />
                        <path
                            id="_x34_50-line"
                            className="st1"
                            d="M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
                        />
                        <path
                            id="_x34_00-line"
                            className="st1"
                            d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
                        />
                        <path
                            id="_x35_00-line"
                            className="st1"
                            d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue2
